// Core
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// Styles
import './styles.scss';
import { restAPIs } from 'utils/restAPIs';
import { fetchData } from 'utils/fetch';
import validator from 'validator';


// icons
import EastOutlinedIcon from '@mui/icons-material/EastOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import InputField from 'components/commonComponents/InputField';
import TextArea from 'components/commonComponents/TextArea';
import Button from 'components/commonComponents/Button';

const Contact = () => {
    const { t } = useTranslation();
    const [isLoading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [error, setError] = useState('');
    const { name, email = '', phone, message, captcha } = data;
    const [response, setResponse] = useState('')

    const handleOnChange = (key) => (value) => {
        setError({
            ...error,
            [key]: null
        });
        setData({
            ...data,
            [key]: value
        });
    };

    const onChange = (value) => {
        setError({
            ...error,
            captcha: null
        });
        setData({
            ...data,
            captcha: value
        });
    }


    const handleSubmit = async () => {
        const errors = {
            name: !name,
            phone: !phone,
            email: !email || !validator.isEmail(email) && 'Enter valid email',
            message: !message,
        };
        setError(errors);
        let isFormValid = Object.values(errors).every((item) => !item);
        if (!isFormValid) return;
        setLoading(true);
        const formData = new FormData();
        formData.append('action', 'contact');
        formData.append('name', name);
        formData.append('email', email);
        formData.append('phone', phone);
        formData.append('message', message);
        const res = await fetchData(restAPIs.contact(formData));
        console.log("res", res);
        setData({})
        setError({})
        setResponse('Yor message Sent successfully.!')
        setTimeout(() => {
            setResponse('')
        }, 3000);

        setLoading(false);

    }


    return (
        <>
            <div className='container mt-5'>
                <div className='row justify-content-center'>
                    <div className='col-md-8'>
                        <h1>{t('contact')}</h1>
                        <p className='mb-5'>Feel free to contact me for any projects or exhibition</p>
                        <div className='row __lets-chat'>
                            <div className='col-md-4 __only_phone'>
                                <p>{t('phone')}</p>
                                <p><a href="tel:+97126666004" style={{direction:'ltr'}}>+971 2 666 6004</a></p>
                            </div>
                            <div className='col-md-4'>
                                <p>{t('email')}</p>
                                <p><a href="mail:sheikhaartt@gmail.com">sheikhaartt@gmail.com</a></p>
                            </div>
                            <div className='col-md-4'>
                                <p>Social Media</p>
                                <p><a href="https://www.instagram.com/sheikhaart/" target='_blank'><InstagramIcon /></a></p>
                            </div>
                        </div>

                        <div className='row mt-4'>
                            <div className='col-md-4 mb-3'>
                                <InputField
                                    type="text"
                                    label={t('name')}
                                    value={name}
                                    onChange={handleOnChange('name')}
                                    error={error.name}
                                />
                            </div>
                            <div className='col-md-4 mb-3'>
                                <InputField
                                    type="email"
                                    label={t('email')}
                                    value={email}
                                    onChange={handleOnChange('email')}
                                    error={error.email}
                                />
                            </div>
                            <div className='col-md-4 mb-3'>
                                <InputField
                                    type="number"
                                    label={t('phone')}
                                    value={phone}
                                    onChange={handleOnChange('phone')}
                                    error={error.phone}
                                />
                            </div>
                            <div className='col-md-12 mb-3'>
                                <TextArea
                                    type="text"
                                    label={t('message')}
                                    value={message}
                                    onChange={handleOnChange('message')}
                                    height={150}
                                    error={error.message}
                                />
                            </div>
                            <div className='mb-2 mt-2'>
                                <Button
                                    label={t('submit')}
                                    icon={<EastOutlinedIcon />}
                                    handleOnClick={handleSubmit}
                                    withLoader
                                    loading={isLoading}
                                    disabled={isLoading}
                                    style={{ margin: 0 }}
                                />
                            </div>
                            <p className={''}>{response}</p>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default Contact;
